// src/routes/UserProtectedRoute.js
import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import LoadingSpinner from "../valtek-ec/components/AdminSpinner";

const UserProtectedRoute = ({ element }) => {
    const { isAuthenticated, loading, logout } = useAuth();
    const [tokenChecked, setTokenChecked] = useState(false);

    useEffect(() => {
        const token = localStorage.getItem("token");

        if (!token) {
            logout?.();
        }

        setTokenChecked(true);
    }, [logout]);

    if (loading || !tokenChecked) return <LoadingSpinner />;

    if (!isAuthenticated) {
        // return <Navigate to="/login" replace />;
        return <Navigate to="/" state={{ showLogin: true }} replace />;

    }

    return element;
};

export default UserProtectedRoute;
